import { render, staticRenderFns } from "./MovementListPage.vue?vue&type=template&id=27556c5a&scoped=true"
import script from "./MovementListPage.vue?vue&type=script&lang=js"
export * from "./MovementListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27556c5a",
  null
  
)

export default component.exports